// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"bb73731a","778":"acd575cc"}[chunkId] + ".chunk.css";
};